import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { GerenciamentoIfoodForm } from "./components/GerenciamentoIfoodForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Gerenciamento iFood" />
            <Loading />
            <GerenciamentoIfoodForm />
        </>
    )
}
